
<div style="display: flex; flex-direction: row;">
    <div style="flex: 1">
        <kendo-chart>
            <kendo-chart-series>
            <kendo-chart-series-item
                type="donut"
                [autoFit]="true"
                [data]="(flowChartData$ | async)"
                categoryField="state"
                field="count"
                colorField="colour"
                >
                <kendo-chart-series-item-labels
                [content]="labelContent"
                color="white"
                background="none"
                >
                </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-legend position="right" orientation="vertical">
            </kendo-chart-legend>
            <ng-template kendoChartDonutCenterTemplate>
                Flows
            </ng-template>                                
        </kendo-chart>
    </div>
    <div style="flex: 1">
        <kendo-chart>
            <kendo-chart-series>
            <kendo-chart-series-item
                type="donut"
                [data]="(runChartData$ | async)"
                categoryField="status"
                colorField="colour"
                field="count"
            >
                <kendo-chart-series-item-labels
                    [content]="labelContent"
                    color="white"
                    background="none"
                >
                </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-legend position="right" orientation="vertical">
            </kendo-chart-legend>
            <ng-template kendoChartDonutCenterTemplate>
                Runs
            </ng-template>                                
        </kendo-chart>
    </div>
</div>
